// extracted by mini-css-extract-plugin
module.exports = {"card":"Styles_card__kiAKp","title":"Styles_title__DOHd_","image":"Styles_image__WdyJ2"};